import React, { useEffect, useState } from 'react';
import { Typography, SxProps } from '@mui/material';
import CircleIcon from '@mui/icons-material/Circle';
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import './ModalheaderTitle.css';
import _ from 'lodash';

interface ModalHeaderTitleProps {
  title: string;
  rawTitleOnly?: boolean;
  sx?: SxProps;
  showKonnectStatusWithHeader?: boolean;
  getDeviceLinkStatus: any;
}

const ModalHeaderTitle: React.FC<ModalHeaderTitleProps> = ({ title, rawTitleOnly = false, sx, showKonnectStatusWithHeader, getDeviceLinkStatus }) => {
  const [onlineStatus, setOnlineStatus] = useState(true);

  useEffect(() => {
    if (showKonnectStatusWithHeader && !_.isEmpty(getDeviceLinkStatus)) {
      const status = getDeviceLinkStatus && getDeviceLinkStatus.hasOwnProperty('success') && getDeviceLinkStatus?.success ? true : false;
      setOnlineStatus(status);
    }
  }, [getDeviceLinkStatus])

  return (
    <Typography className="modal-title" sx={sx}>
      {rawTitleOnly ? (
        title
      ) : (
        <>
            <span className="title-label">Configuration</span>
            {showKonnectStatusWithHeader ?
              <span className="title-alias">
                <CircleIcon id={onlineStatus ? "greenDotSymbol" : "redDotSymbol"} />
                &nbsp;{title}
              </span>
              :
              <span className="title-alias">&nbsp;{title}</span>
            }
        </>
      )}
    </Typography>
  );
};

const mapStateToProps = (state) => ({
  getDeviceLinkStatus: state.authReducer.getDeviceLinkStatus,
});

export default withRouter(
  connect(mapStateToProps, {  })(ModalHeaderTitle)
)
